import axios from '@/utils/api'
import empty from './empty'
import {
  SET_ORDEM_SERVICO,
  CLEAR_ORDEM_SERVICO,
  CLEAR_PROCESSOS_SELECIONADOS,
  SET_PROCESSOS_SELECIONADOS,
  ADD_SUB_PROCESSO_SELECIONADOS,
  SET_NULL_USUARIO_SUB_PROCESSO,
  SET_USUARIO_SUB_PROCESSO,
  SET_LISTA_AUXILIAR
} from '../../mutation-types'
import localStorage, { KEYS } from '../../local/localStorage'

const state = empty.state.emptyProcesso()

const subProcessos = empty.state.createEmptySubProcessos()

const getters = {}

const actions = {
  async getOrdemServicoPorNumero ({ commit }, id) {
    const data = await axios({
      method: 'GET',
      url: `ordemServico/findById/${id}`
    })
    commit(SET_ORDEM_SERVICO, data)
    return data
  },

  setListaProcessoAuxiliar ({ commit }, processo) {
    commit(SET_LISTA_AUXILIAR, processo)
  },

  async verificaNumeroOs ({ commit }, { numero, id }) {
    const data = await axios({
      method: 'GET',
      url: `ordemServico/verificaNumeroOs?numero=${numero}&id=${id}`
    })
    return data
  },

  async deleteOrdemServicoPorId ({ commit }, id) {
    const data = await axios({
      method: 'DELETE',
      url: `ordemServico/${id}`
    })
    return data
  },

  async getOrdemServico ({ commit }, { dados }) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `ordemServico/filtro`
    })
    return data
  },

  async getProcessoByOrdemServico ({ commit }, { dados }) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `ordemServico/processo/filtro`
    })
    return data
  },

  async getAnalistas ({ commit }) {
    const data = await axios({
      method: 'get',
      url: 'ordemServico/getAnalistas/TECNICO_DE_CAMPO'
    })

    return _.map(data, (usuario) => { // eslint-disable-line
      return {
        nome: usuario.pessoa.pessoaFisica.nome,
        selecionado: false,
        quantidadeOrdemServico: usuario.quantidadeOrdemServico,
        perfis: usuario.perfis,
        id: usuario.id
      }
    })
  },

  async getAnalistasTEQ ({ commit }) {
    const data = await axios({
      method: 'get',
      url: 'ordemServico/getAnalistasTEQ'
    })
    return _.map(data, (usuario) => { // eslint-disable-line
      return {
        nome: usuario.pessoa.pessoaFisica.nome,
        selecionado: false,
        quantidadeOrdemServico: usuario.quantidadeOrdemServico,
        perfis: usuario.perfis,
        id: usuario.id
      }
    })
  },

  async salvar ({ commit }, dados) {
    const subProcessos = _.map(dados.processos, (subProcesso) => { // eslint-disable-line
      return {
        ...subProcesso,
        status: null,
        processo: { id: subProcesso.processo.id }
      }
    })

    dados = { ...dados, processos: subProcessos }

    const data = await axios({
      method: 'post',
      data: dados,
      url: `ordemServico`
    })

    return data
  },

  clear ({ commit }) {
    commit(CLEAR_ORDEM_SERVICO, {})
    commit(CLEAR_PROCESSOS_SELECIONADOS, [])
    localStorage.setItem(KEYS.SUBPROCESSOS_SELECIONADOS_OS, null)
  },

  setProcessoSelecionados ({ commit }, { processos, map }) {
    commit(SET_PROCESSOS_SELECIONADOS, { processos, map })
    return { processos }
  },

  addSubProcessoSelecionado ({ commit }, { subProcesso }) {
    commit(ADD_SUB_PROCESSO_SELECIONADOS, { subProcesso })
    return subProcesso
  },

  setUsuarioNullSubProcesso ({ commit }, { numeroProcesso }) {
    commit(SET_NULL_USUARIO_SUB_PROCESSO, { numeroProcesso })
    return true
  },

  setUsuarioSubProcesso ({ commit }, { subProcesso, usuario }) {
    commit(SET_USUARIO_SUB_PROCESSO, { subProcesso, usuario })
    return true
  },

  getProcessoSelecionados () {
    return state.processos
  },

  async getSubProcessoSelecionados () {
    return new Promise(async (resolve, reject) => {
      const subProcessos = JSON.parse(await localStorage.getItem(KEYS.SUBPROCESSOS_SELECIONADOS_OS))
      if (subProcessos) {
        state.subProcessos = subProcessos
      }
      resolve(subProcessos)
    })
  }

}

const mutations = {
  [SET_ORDEM_SERVICO] (state, ordemServico) {
    state.ordemServico = ordemServico
  },

  [CLEAR_ORDEM_SERVICO] (state) {
    state.ordemServico = empty.state.emptyProcesso().ordemServico
    state.listaProcessosAuxiliar = []
  },

  [SET_LISTA_AUXILIAR] (state, processo) {
    if (processo.selecionado) {
      if (state.listaProcessosAuxiliar.find(process => processo.id !== process.id)) {
        state.listaProcessosAuxiliar.push(processo)
      }
    } else {
      state.listaProcessosAuxiliar = state.listaProcessosAuxiliar.filter((p) => p.id !== processo.id)
    }
  },

  [CLEAR_PROCESSOS_SELECIONADOS] (state) {
    state.processos = empty.state.emptyProcesso().processos
    state.subProcessos = empty.state.createEmptySubProcessos()
  },

  [SET_PROCESSOS_SELECIONADOS] (state, { processos }) {
    let subProcessosSelecionados = []
    _.forEach(processos, (processo) => { // eslint-disable-line

      const processoOrdemServico = state.ordemServico.processos.filter(x => x.processoId === processo.id)
      const setarSubProcessos = processoOrdemServico.length > 0 ? processoOrdemServico : subProcessos

      _.forEach(_.cloneDeep(setarSubProcessos), (subProcesso) => { // eslint-disable-line
        subProcesso.numero = processo.numeroProcesso
        subProcesso.processo = processo
        subProcessosSelecionados.push(subProcesso)
      })
    })
    state.subProcessos = subProcessosSelecionados
    localStorage.setItem(KEYS.SUBPROCESSOS_SELECIONADOS_OS, JSON.stringify(subProcessosSelecionados))
    state.processos = processos
  },

  async [ADD_SUB_PROCESSO_SELECIONADOS] (state, { subProcesso }) {
    let subProcessosSelecionados = JSON.parse(await localStorage.getItem(KEYS.SUBPROCESSOS_SELECIONADOS_OS))
    subProcessosSelecionados.push(subProcesso)
    localStorage.setItem(KEYS.SUBPROCESSOS_SELECIONADOS_OS, JSON.stringify(subProcessosSelecionados))
  },

  async [SET_NULL_USUARIO_SUB_PROCESSO] (state, { numeroProcesso }) {
    let subProcessosSelecionados = JSON.parse(await localStorage.getItem(KEYS.SUBPROCESSOS_SELECIONADOS_OS))
    if (subProcessosSelecionados.find(p => p.numero === numeroProcesso && p.funcao === 'GEOMENSOR')) {
      subProcessosSelecionados.find(p => p.numero === numeroProcesso && p.funcao === 'GEOMENSOR').usuario.id = null
    }
    if (subProcessosSelecionados.find(p => p.numero === numeroProcesso && p.funcao === 'FISCALIZADOR')) {
      subProcessosSelecionados.find(p => p.numero === numeroProcesso && p.funcao === 'FISCALIZADOR').usuario.id = null
    }
    localStorage.setItem(KEYS.SUBPROCESSOS_SELECIONADOS_OS, JSON.stringify(subProcessosSelecionados))
  },

  async [SET_USUARIO_SUB_PROCESSO] (state, { subProcesso, usuario }) {
    let subProcessosSelecionados = JSON.parse(await localStorage.getItem(KEYS.SUBPROCESSOS_SELECIONADOS_OS))
    subProcessosSelecionados.find(p => p.numero === subProcesso.numero && p.funcao === subProcesso.funcao).usuario.id = usuario
    await localStorage.setItem(KEYS.SUBPROCESSOS_SELECIONADOS_OS, JSON.stringify(subProcessosSelecionados))
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/ordemServico.js